import { TweenLite } from 'gsap/TweenLite';
import isSafari from '@/scripts/utils/detect-safari';
import isMobile from '@/scripts/utils/detect-mobile';
import './HomeServices.scss';

const defaults = {
  element: null,
  items: '[data-role="services-item"]',
  listItems: '[data-role="services-list-item"]',
  closeItem: '[data-role="services-close"]',
  hoveredClass: 'is-hovered',
  activeClass: 'is-active',
  openedClass: 'is-opened',
};

export default class HomeServices {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.element = options.element;
    if (!this.element) return;

    this.items = this.element.querySelectorAll(options.items);
    this.listItems = this.element.querySelectorAll(options.listItems);
    this.listButtons = this.element.querySelectorAll(options.closeItem);
    this.hoveredClass = options.hoveredClass;
    this.activeClass = options.activeClass;
    this.openedClass = options.openedClass;

    this.contentOpened = false;
    this.transitionDuration = document.documentElement.dataset.duration;
    this.init();
  }

  scrollToTop() {
    if (!isSafari()) {
      const offset = this.element.getBoundingClientRect().top + window.scrollY - 80;
      TweenLite.to(window, this.transitionDuration, { scrollTo: { y: offset, autoKill: false } });
    }
  }

  init() {
    this.listItems.forEach((item, i) => {
      if (!isMobile()) {
        item.addEventListener('mouseenter', () => {
          if (this.contentOpened) return;
          item.classList.add(this.hoveredClass);
          this.items[i].classList.add(this.hoveredClass);
        });
        item.addEventListener('mouseleave', () => {
          item.classList.remove(this.hoveredClass);
          this.items[i].classList.remove(this.hoveredClass);
        });
      }
      item.addEventListener('click', () => {
        item.classList.add(this.activeClass);
        this.items[i].classList.add(this.activeClass);
        this.element.classList.add(this.openedClass);
        this.contentOpened = true;
        this.scrollToTop();
      });
    });
    this.listButtons.forEach((button, i) => {
      button.addEventListener('click', () => {
        this.element.classList.remove(this.openedClass);
        this.items[i].classList.remove(this.activeClass);
        this.listItems[i].classList.remove(this.activeClass);
        this.contentOpened = false;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/HomeServices/HomeServices.js